import React from 'react';

import useRedux from 'hooks/useRedux';

import * as actionsGroupList from './account.duck';
// import * as editorActionsGroupList from '../portfolioEntry/portfolioEntry.duck';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import Login from '../login/Login';

import Heading from '../home/components/Heading';
import Footer from '../home/components/Footer';
import ContentSection from '../home/components/ContentSection';

const Main = (props) => {
    const { match, } = props;
    const { params } = match;

    const [state, actions] = useRedux(actionsGroupList);

    const account = state.account;

    React.useEffect(() => {

        actions.loadPasswordReset({ id: params.id });
    }, []);

    const [newPassword, newPassword_set] = React.useState("");
    const [newPasswordConfrim, newPasswordConfrim_set] = React.useState("");
    const [submitted, submitted_set] = React.useState();
    const [showLogin, showLogin_set] = React.useState(false);

    const [customError, customError_set] = React.useState("");

    const { resetEmail, error, passwordResettingSuccess, passwordResetting } = account;

    const canSubmit = newPassword === newPasswordConfrim && newPassword.length >= 8 && !passwordResetting;

    return <div>
        <Heading buttons={[
        ]} />
        <ContentSection>
            {!resetEmail && <div>
                {!error && <div>Loading...</div>}
                {error && <div>{error.data}</div>}
            </div>}
            {resetEmail && <div>
                {(!passwordResettingSuccess || !submitted) && <div>
                    <div>Resetting password for account {resetEmail}</div>
                    <div style={{ width: 300 }}>
                        <div>Enter New Password:</div>
                        <TextField
                            id="outlined-name"
                            // placeholder="Email"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            type="text"
                            style={{ marginTop: 5 }}
                            value={newPassword}
                            onChange={(event) => {
                                newPassword_set(event.target.value);
                            }}
                            inputProps={{
                                style: {
                                    padding: 10,
                                }
                            }}
                            disabled={passwordResetting}
                        />
                    </div>
                    <div style={{ width: 300 }}>
                        <div>Confirm Password:</div>
                        <TextField
                            id="outlined-name"
                            // placeholder="Email"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            type="text"
                            style={{ marginTop: 5 }}
                            value={newPasswordConfrim}
                            onChange={(event) => {
                                newPasswordConfrim_set(event.target.value);
                            }}
                            inputProps={{
                                style: {
                                    padding: 10,
                                }
                            }}
                            disabled={passwordResetting}
                        />
                    </div>
                    {error && <div>
                        {error.data}
                    </div>}
                    {customError && <div>
                        {customError}
                    </div>}
                    <div>
                        <Button variant={'outlined'} color={'primary'}
                            onClick={() => {
                                if (!canSubmit) {
                                    if (newPassword !== newPasswordConfrim) {
                                        customError_set("Passwords must match");
                                    }
                                    else {
                                        customError_set("Password must be at least 8 characters long");
                                    }
                                }
                                else {
                                    actions.submitPasswordReset({
                                        ...props, password: newPassword, id: params.id, onError: () => {
                                            submitted_set(false);
                                        }
                                    });
                                    submitted_set(true);
                                    customError_set("");
                                }
                            }}>Submit</Button>
                    </div>
                </div>}
                {passwordResettingSuccess && submitted && <div>
                    <div>
                        Your password has been reset. Please log in using your new password.
                    </div>
                    <div>
                        <Button variant={'outlined'} color={'primary'} onClick={() => {
                            showLogin_set(true);
                        }}>Log In</Button>
                        {showLogin && <div>
                            <Login onLoggedIn={(success) => {
                                if (success)
                                    window.location = "/#";
                                else {
                                    showLogin_set(false);
                                }
                            }} showLogin={true} showCreateAccount={false} />
                        </div>}
                    </div>
                </div>}
            </div>}
        </ContentSection>
        <Footer />
    </div>

}
export default Main;



// WEBPACK FOOTER //
// ./src/account/PasswordReset.js